// extracted by mini-css-extract-plugin
module.exports = {"code":"F-docs-code-code-1b6ko","codeBlock":"F-docs-code-code-block-2vKvD"};